// extracted by mini-css-extract-plugin
module.exports = {"xbert-tooltip":"DgfMO-","xbertTooltip":"DgfMO-"};